<template>
    <div>
        <h2 class="card-title">약국정보 관리
            <p class="profile-notice">* 프로필 이미지 및 약국정보 등 반드시 등록하셔야 합니다.</p>
        </h2>
        <div class="profile clearfix">
            <div class="profile-img" >
                <p class="profile-img-wrap" :title="img_title_view(this.account.pharm_img_sm)">
                    <img :src="account.pharm_img_sm" alt="">
                </p>
                <!-- <button type="button" @click="$router.push(`/profile/edit`)">수정</button> -->
            </div>
            <div class="profile-txt">
                <h4 class="name">{{ account.pharm_name }}</h4>
                <p class="last">
                    마지막 접속일시&nbsp;
                    <span class="date">{{ account.last_login_at | date_format('YYYY-MM-DD HH:mm:ss') }}</span> 
                </p>
                
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { nameByConstMixin } from '@/lib/mixins'

    export default {
      mixins: [nameByConstMixin],
      name: 'profile',
      props: ['pharm_id'],
      computed: {
        ...mapState(['account'])
    },
    mounted () {

    }
  }
</script>

<style scoped>
    /* 홈카드 공통 */
    .card-title {
        color: #4c4c4c;
        position: relative;
        margin-bottom: 20px;
        font: 600 20px 'Noto Sans KR', sans-serif;
    }

    /* 프로필 관리 */
    .profile > div {
        float: left;
        padding: 30px 0;
    }

    .profile-img {
        width: 170px;
        text-align: center;
    }

    .profile-img > p {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto 20px;
        border-radius: 50%;
        background-image: url('../../assets/home/profile-default.jpg');
    }

    .profile-img img {
        width: 100%
    }

    .profile-img-wrap {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #ccc;
        font-size: 10px;
        overflow: hidden;
    }

    .profile-img > button {
        color: #fff;
        outline: 0;
        border: none;
        padding: 7px 12px;
        cursor: pointer;
        background-color: #6e6fe5;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .profile-txt {
        width: 300px;
    }

    .profile-txt .cate {
        display: inline-block;
        color: #6e6fe5;
        padding: 4px 22px;
        box-sizing: border-box;
        border: 1px solid #6e6fe5;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .profile-txt .name {
        margin: 7px 0 5px;
        font: 500 32px 'Noto Sans KR', sans-serif;
    }

    .profile-txt .recommend > p,
    .profile-txt .recommend > span {
        float: left;
        color: #999;
    }

    .profile-txt .recommend > p {
        text-indent: 25px;
        font: 500 16px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/star.png) 0 center/18px no-repeat;
    }

    .profile-txt .recommend > span {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 5px 0 0 7px;
        text-align: center;
        border: 1px solid #999;
        border-radius: 50%;
        box-sizing: border-box;
        font: 600 8px/14px 'Noto Sans KR', sans-serif;
    }

    .profile-txt .last {
        color: #999;
        margin-top: 32px;
        font: 400 13px 'Noto Sans KR', sans-serif;
    }

    .profile-notice {
        color: #adadad;
        margin: 2px 0 16px;
        letter-spacing: -.5px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .overseas-set-check {
        display: block;
        text-indent: 25px;
        cursor: pointer;
        position: relative;
        font: 400 15px 'Noto Sans KR', sans-serif;
    }

</style>